import { AdvancedSearchData } from '@/components/search/types';

/**
 * Search on connected werklijnen.
 * @returns
 * @param treinnummer
 * @param treindatum
 */
export const searchRequestConnectedWerklijnen = (treinnummer: string, treindatum: string): AdvancedSearchData => {
  return {
    criteria: [
      { veld: 'beweging.treinnummer', waarden: [Number.parseInt(String(treinnummer))] },
      { veld: 'verkeersdatum', waarden: [treindatum] },
    ],
  };
};
